import React from 'react';
import { XIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { SectionLabel } from './SectionLabel';
const pains = ['Compraste una repisa y sigue guardada porque no sabés cómo instalarla.', 'Te da miedo usar el taladro y romper la pared.', 'No sabés qué tornillos, tarugos o brocas comprar.', 'Cada vez que querés hacer algo, tenés que esperar que alguien te ayude.', 'Pagás por arreglos simples que podrías hacer vos mismo.', 'Intentaste una vez y quedó torcido o se cayó.', 'Querés ordenar tu casa pero no sabés por dónde empezar.'];
export function PainPoints() {
  return <section aria-labelledby="identificas-titulo" className="w-full border-y-2 border-ink bg-sand" data-id="element-140" data-mp="1o0lmxgem9ma2">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:px-8 sm:py-20" data-id="element-141" data-mp="1sz6n5ftvc5yi">
        <Reveal data-id="element-142" data-mp="3idbf9tpc6nfc">
          <SectionLabel data-id="element-143" data-mp="3iewc5pz4iigd">¿Te identificás con esto?</SectionLabel>
          <h2 id="identificas-titulo" className="mt-4 max-w-2xl font-display text-3xl font-bold leading-tight sm:text-[2.6rem]" data-id="element-144" data-mp="3ncfo2j8cmj55">
            ¿Cuántas cosas tenés pendientes en tu casa?
          </h2>
          <p className="mt-5 max-w-2xl text-lg leading-relaxed text-graphite" data-id="element-145" data-mp="1u0smaldxdpxk">
            Seguramente hay una repisa guardada, cortinas sin colgar, cuadros
            apoyados en el piso o pequeños arreglos que llevan meses esperando.
            No es falta de ganas. Es que nadie te enseñó cómo hacerlo de forma
            simple y segura.
          </p>
        </Reveal>

        <ul className="mt-10 grid gap-3 sm:grid-cols-2" data-id="element-146" data-mp="1b3hoz6but6kr">
          {pains.map((pain, i) => <Reveal key={pain} delay={i * 0.05} data-id="element-147" data-mp="1p30m7434mxia" data-mpi={i}>
              <li className="flex h-full items-start gap-3 rounded-2xl border-2 border-ink/15 bg-cream px-5 py-4" data-id="element-148" data-mp="1p3sdw3tlsb3a">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-clay/12 text-clay" data-id="element-149" data-mp="1k5qwrofqmlug">
                  <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-150" data-mp="2vj2tzggzs67n" />
                </span>
                <span className="text-[15px] leading-relaxed text-graphite" data-id="element-151" data-mp="1t5f1vzlmhb3r">
                  {pain}
                </span>
              </li>
            </Reveal>)}
        </ul>

        <Reveal delay={0.1} data-id="element-152" data-mp="225tqb7tvv6bh">
          <p className="mt-10 max-w-2xl font-display text-xl font-bold leading-snug sm:text-2xl" data-id="element-153" data-mp="225lbhae79qxn">
            Si te identificaste con alguno de estos puntos, este libro digital
            fue creado exactamente para vos.
          </p>
        </Reveal>
      </div>
    </section>;
}